/* Renomme le bouton natif Shopify selon le viewport : « Accepter » sur mobile,
   « Accepter les cookies » sur desktop. Le libellé n'est pas exposé côté Admin
   ni dans les locales du thème (texte platform Shopify) : seule une
   réécriture du texte réel du bouton, une fois injecté, permet ce changement
   sans casser l'accessibilité (le lecteur d'écran doit annoncer le même mot
   que ce qui est visible, pas juste un habillage visuel en CSS). */
(function () {
  var LABEL_DESKTOP = "Accepter les cookies";
  var LABEL_MOBILE = "Accepter";
  var MOBILE_QUERY = "(max-width: 39.999rem)";

  function getLabel() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches
      ? LABEL_MOBILE
      : LABEL_DESKTOP;
  }

  function relabel(button) {
    var label = getLabel();
    if (button && button.textContent !== label) {
      button.textContent = label;
    }
  }

  function watchViewport() {
    if (!window.matchMedia) return;

    var media = window.matchMedia(MOBILE_QUERY);
    var handleChange = function () {
      var button = document.querySelector("#shopify-pc__banner__btn-accept");
      if (button) relabel(button);
    };

    if (media.addEventListener) {
      media.addEventListener("change", handleChange);
    } else if (media.addListener) {
      media.addListener(handleChange);
    }
  }

  var existing = document.querySelector("#shopify-pc__banner__btn-accept");
  if (existing) {
    relabel(existing);
    watchViewport();
    return;
  }

  var observer = new MutationObserver(function () {
    var button = document.querySelector("#shopify-pc__banner__btn-accept");
    if (button) {
      relabel(button);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  watchViewport();
})();
